import { ECountry } from '@/shared/enum/country.enum'
import { EPhoneCode } from '@/shared/enum/phone-code.enum'

const getCountryFromPhoneCode = (phoneCode: EPhoneCode): ECountry => {
  const countries = new Map([
    [EPhoneCode.GT, ECountry.GT],
    [EPhoneCode.CR, ECountry.CR],
    [EPhoneCode.HN, ECountry.HN],
    [EPhoneCode.NI, ECountry.NI],
    [EPhoneCode.SV, ECountry.SV]
  ])

  return countries.get(phoneCode)!
}

export default getCountryFromPhoneCode
